import { RecalProcessAndGenConstant } from "presentation/constant/Recalculation/RecalProcessAndGenConstant";
import { useRecalProcessAndGenVM } from "presentation/hook/Recalculation/useRecalProcessAndGenVM";
import { useRecalProcessAndGenMaintenanceTracked } from "presentation/store/Recalculation/RecalProcessAndGenMaintenanceProvider";
import { CriteriaItemContainer } from "presentation/view/components/CriteriaItemContainer";
import { NbisCommonField } from "presentation/view/components/NbisCommonField";
import { useCallback, useMemo } from "react";
import { FieldType, HPHButton, IconButton, IFieldValue } from "veronica-ui-component/dist/component/core";
import { SidebarActionBar, SidebarActionCross, Sidebarheader, SidebarTitle } from "veronica-ui-component/dist/component/core/styled/uiFramework.styled";

const RecalProcessAndGenSubmitEditPanel = () => {
    const SCREEN_CONSTANT = RecalProcessAndGenConstant;
    const [recalProcessAndGenState] = useRecalProcessAndGenMaintenanceTracked();
    const recalProcessAndGenVM = useRecalProcessAndGenVM();
    const { currentSubmitEditRow } = recalProcessAndGenState;

    const handleSave = useCallback(async () => {
        recalProcessAndGenVM.onSaveSubmitEditRow(currentSubmitEditRow);
    }, [currentSubmitEditRow, recalProcessAndGenVM]);

    const handClose = useCallback(() => {
        recalProcessAndGenVM.onCloseSubmitEditPanel();
    }, [recalProcessAndGenVM]);

    const handReset = useCallback(() => {
        recalProcessAndGenVM.onResetSubmitEditPanel();
    }, [recalProcessAndGenVM]);

    const memoBillToCompany = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "220px", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={true}
                isShowOptional={false}
                readOnlyValue={currentSubmitEditRow?.billToCompany ?? ''}
                fieldValue={currentSubmitEditRow?.billToCompany ?? ''}
                fieldLabel={SCREEN_CONSTANT.BILLTO_COMPANY}
                isSaveClicked={false}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'billToCompany'}
                maxLength={60}
                isLimitOptions={true}
                options={recalProcessAndGenState.dynamicOptions.companyCodeDropdownOptions}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    recalProcessAndGenVM.onEditFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [currentSubmitEditRow?.billToCompany, SCREEN_CONSTANT.BILLTO_COMPANY, recalProcessAndGenState.dynamicOptions.companyCodeDropdownOptions, recalProcessAndGenVM])

    const memoOldTariff = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "220px", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={false}
                isShowOptional={false}
                readOnlyValue={currentSubmitEditRow?.oldTariff ?? ''}
                fieldValue={currentSubmitEditRow?.oldTariff ?? ''}
                fieldLabel={SCREEN_CONSTANT.OLD_TARIFF}
                isSaveClicked={false}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'oldTariff'}
                maxLength={60}
                isLimitOptions={true}
                options={recalProcessAndGenState.dynamicOptions.oldRecalProposalSetDropdownOptions}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    recalProcessAndGenVM.onEditFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [currentSubmitEditRow?.oldTariff, SCREEN_CONSTANT.OLD_TARIFF, recalProcessAndGenState.dynamicOptions.oldRecalProposalSetDropdownOptions, recalProcessAndGenVM])


    const memoNewTariff = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "220px", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={false}
                isShowOptional={false}
                readOnlyValue={currentSubmitEditRow?.newTariff ?? ''}
                fieldValue={currentSubmitEditRow?.newTariff ?? ''}
                fieldLabel={SCREEN_CONSTANT.NEW_TARIFF}
                isSaveClicked={false}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'newTariff'}
                maxLength={60}
                isLimitOptions={true}
                options={recalProcessAndGenState.dynamicOptions.newRecalProposalSetDropdownOptions}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    recalProcessAndGenVM.onEditFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [currentSubmitEditRow?.newTariff, SCREEN_CONSTANT.NEW_TARIFF, recalProcessAndGenState.dynamicOptions.newRecalProposalSetDropdownOptions, recalProcessAndGenVM])


    return (
        <div className='side-form-content-wrapper'>
            <div className={'flex-row'}>
                <div className={'flex-row-item flex-row-item-full-width'}>
                    <Sidebarheader>
                        <SidebarTitle>
                            {"Submit"}
                        </SidebarTitle>
                        <SidebarActionCross>
                            <IconButton
                                fileName="Icon-cross" size="medium" toolTipText='Close' toolTipArrow={false} onClick={handClose} />
                        </SidebarActionCross>
                    </Sidebarheader>
                </div>
            </div>
            <div className={'add-edit-form'} style={{ height: '75vh', maxHeight: '75vh', overflow: 'auto' }}>
                <div className="flex-row-auto">
                    <div className={'flex-row-item'}>

                        <CriteriaItemContainer>
                            {memoBillToCompany}
                        </CriteriaItemContainer>

                        <CriteriaItemContainer>
                            {memoOldTariff}
                        </CriteriaItemContainer>

                        <CriteriaItemContainer>
                            {memoNewTariff}
                        </CriteriaItemContainer>

                    </div>
                </div>
            </div>
            <SidebarActionBar>
                <HPHButton label={'Reset'} size={'Small'} theme={'Secondary'} onClick={handReset} />
                <HPHButton label={'Save'} size={'Small'} theme={'Primary'} onClick={handleSave} />
            </SidebarActionBar>
        </div>
    );
}

export default RecalProcessAndGenSubmitEditPanel;
